// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"116":"graphs","341":"modals","821":"eventlog","942":"admin-tools"}[chunkId] + "." + {"116":"b33cc761","341":"3e1d3090","821":"a529f601","942":"3ee15b51"}[chunkId] + ".css";
};